import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { guid } from '@/mixins/guid';
import { uploader } from '@/mixins/aws/uploader/s3';
import uploadProgress from '@/mixins/aws/uploader';

export default Vue.component('dynamic-external-media', {
  template: require('./template.html'),
  name: 'dynamic-external-media',
  mixins: [guid, uploader],
  computed: {
    ...mapGetters(['currentSite']),
  },
  components: {
    uploadProgress,
  },
  props: [
    'active-item',
    'type',
    'value',
    'inner-tabs',
    'dynamic-tab',
  ],
  data() {
    return {
      platformErrors: {},
      display: {},
    };
  },
  watch: {
    innerTabs: {
      handler(tab) {
        if (tab[this.dynamicTab]) {
          this.setInitialValues();
        }
      },
      deep: true,
    },
  },
  created() {
    this.setInitialValues();
  },
  methods: {
    setInitialValues() {
      _.forOwn(this.activeItem[this.type], (value, key) => {
        this.$set(this.display, key, value || '');
        this.$set(this.platformErrors, key, false);
      });
    },
    updateExternals(platform) {
      const input = this.display[platform];
      const val = this._getInputVal(input);
      this.$store.dispatch('setDropletVal', {
        drp: this.activeItem[this.type],
        key: platform,
        val,
      });
    },
    formatErrors(ers) {
      return ers.join(' ');
    },
    startCase(text) {
      return _.startCase(text);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/dynamic-data/edit-item/inputs/external-media/index.js